import { render, staticRenderFns } from "./CarouselManager.vue?vue&type=template&id=1b3e8982&scoped=true"
import script from "./CarouselManager.vue?vue&type=script&lang=js"
export * from "./CarouselManager.vue?vue&type=script&lang=js"
import style0 from "./CarouselManager.vue?vue&type=style&index=0&id=1b3e8982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3e8982",
  null
  
)

export default component.exports